import { SelectOption } from "@aurem/ui";
import { ScheduleFrequency } from "./types";

export const FREQUENCY_ORDER: ScheduleFrequency[] = [
  "daily",
  "weekly",
  "monthly",
  "yearly",
];

export function resolveAllowedFrequencies(
  allowedFrequencies?: ScheduleFrequency[],
): ScheduleFrequency[] {
  const allowedSet = new Set(
    (allowedFrequencies ?? []).map(
      (frequency) => frequency.toLowerCase() as ScheduleFrequency,
    ),
  );
  const ordered = FREQUENCY_ORDER.filter((frequency) =>
    allowedSet.has(frequency),
  );
  return ordered.length > 0 ? ordered : [...FREQUENCY_ORDER];
}

export function getOrdinalSuffix(num: number): string {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
}

export const createDayOfWeekOptions = (
  t: (key: string) => string,
): SelectOption[] => [
  { id: "1", text: t("components.scheduleControl.weekday.monday") },
  { id: "2", text: t("components.scheduleControl.weekday.tuesday") },
  { id: "3", text: t("components.scheduleControl.weekday.wednesday") },
  { id: "4", text: t("components.scheduleControl.weekday.thursday") },
  { id: "5", text: t("components.scheduleControl.weekday.friday") },
  { id: "6", text: t("components.scheduleControl.weekday.saturday") },
  { id: "0", text: t("components.scheduleControl.weekday.sunday") },
];

export const dayOfMonthOptions: SelectOption[] = Array.from(
  { length: 28 },
  (_, i) => {
    const day = i + 1;
    return {
      id: day.toString(),
      text: `${day}${getOrdinalSuffix(day)}`,
    };
  },
);

export const hourOptions: SelectOption[] = Array.from(
  { length: 24 },
  (_, i) => ({
    id: i.toString().padStart(2, "0"),
    text: `${i.toString().padStart(2, "0")}`,
  }),
);

export const minuteOptions: SelectOption[] = Array.from(
  { length: 60 },
  (_, i) => ({
    id: i.toString().padStart(2, "0"),
    text: `${i.toString().padStart(2, "0")}`,
  }),
);

export const createFrequencyOptions = (
  t: (key: string) => string,
): SelectOption[] => [
  { id: "daily", text: t("components.scheduleControl.frequencyOptions.daily") },
  {
    id: "weekly",
    text: t("components.scheduleControl.frequencyOptions.weekly"),
  },
  {
    id: "monthly",
    text: t("components.scheduleControl.frequencyOptions.monthly"),
  },
  {
    id: "yearly",
    text: t("components.scheduleControl.frequencyOptions.yearly"),
  },
];
